import { useAppSelector } from 'app/hooks';
import MailIcon from 'assets/icons/MailIcon';
import { selectIsShowHomeMenu } from 'features/home/homeSlice';
import React from 'react';

interface HomeSubMenuProps {}

const HomeSubMenu: React.FunctionComponent<HomeSubMenuProps> = () => {
  const isShowHomeMenu = useAppSelector(selectIsShowHomeMenu);

  return (
    <div
      className={`home-sub-menu flex-row items-center justify-center ${
        isShowHomeMenu ? 'home-sub-menu__show' : 'home-sub-menu__hide'
      } primary-text-color`}
    >
      <div className="sub-menu items-center justify-around">
        <a href="mailto:support@terabet.io" className="flex-col items-center gap-1">
          <MailIcon width="20" height="20" />
          <span>Mail</span>
        </a>
      </div>
    </div>
  );
};

export default HomeSubMenu;
